module.exports = __webpack_public_path__ + "static/media/SB2017.bf5cbaf4.jpg";